var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ viewBox: "0 0 11 14" }, props),
    React.createElement("path", { d: "M10.8 8.723l-1.976 2.414a.657.657 0 0 1-1.015 0L5.833 8.723a.657.657 0 0 1 .507-1.071h.967V6.449c0-.843-.687-1.53-1.53-1.53H3.808v5.357h.8c.555 0 .857.642.507 1.07L3.14 13.76a.657.657 0 0 1-1.015 0L.15 11.347a.656.656 0 0 1 .507-1.071h.966V1.093a1.094 1.094 0 0 1 2.187 0v1.64h1.967a3.72 3.72 0 0 1 3.717 3.716v1.203h.8c.556 0 .857.642.507 1.071", fill: "currentColor", fillRule: "evenodd" })
  );
});